import { render, staticRenderFns } from "./biocenose.vue?vue&type=template&id=6edf0b32&scoped=true&"
var script = {}
import style0 from "./biocenose.vue?vue&type=style&index=0&id=6edf0b32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edf0b32",
  null
  
)

export default component.exports